// One document per sent transaction email. This is the deal-page history now
// and the data source for the Stage-3 team-wide hub.
import {
  getFirestore,
  collection,
  addDoc,
  query,
  where,
  orderBy,
  getDocs,
} from "firebase/firestore";

const COLLECTION = "sentEmails";

/**
 * record = { dealId, dealAddress, emailId, sequenceSide, agentId, agentName,
 *   recipientEmail, recipientName, cc, subject, bodyHtml,
 *   attachments: [{name,size,source}], videoUrl, gmailMessageId }
 * sentAt is stamped here.
 */
export async function recordSentEmail(record) {
  const db = getFirestore();
  const ref = await addDoc(collection(db, COLLECTION), {
    ...record,
    sentAt: Date.now(),
  });
  return ref.id;
}

export async function getSentEmailsForDeal(dealId) {
  const db = getFirestore();
  const q = query(
    collection(db, COLLECTION),
    where("dealId", "==", dealId),
    orderBy("sentAt", "desc"),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
